export const figmaPromoBanners = [
  {
    eyebrow: "Limited Offer",
    title: "Save 20% on Brake Kits",
    description:
      "Reliable OEM-grade braking components with fast dispatch across India.",
    cta: "Shop Now",
    href: "/categories/brake-parts",
    image: "/brake_system_category.png",
    tint: "from-slate-950/70 via-slate-900/30 to-slate-900/10",
  },
  {
    eyebrow: "New Arrival",
    title: "Premium OEM Collections",
    description:
      "Fresh arrivals for fitment-focused customers and workshop buyers.",
    cta: "Explore",
    href: "/products",
    image: "/placeholder.jpg",
    tint: "from-slate-950/75 via-slate-900/25 to-slate-900/10",
  },
];

export const figmaTrustItems = [
  {
    title: "Fast Delivery",
    copy: "To 20,000+ Pin codes",
  },
  {
    title: "Genuine Parts",
    copy: "100% Authentic OEM Products",
  },
  {
    title: "Easy Returns",
    copy: "10 Days Return Policy",
  },
  {
    title: "Expert Support",
    copy: "Tech Help via Call/WhatsApp",
  },
];

export const figmaFooterColumns = [
  {
    title: "Shop Parts",
    links: [
      { label: "Brake System", href: "/categories/brake-system" },
      { label: "Engine Components", href: "/categories/engine-parts" },
      { label: "Suspension & Steering", href: "/categories/suspension" },
      { label: "Body Parts", href: "/categories/car-body-and-interior" },
      { label: "Filters & Service Kits", href: "/categories/filters" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About Us", href: "/about-us" },
      { label: "Contact Us", href: "/contact-us" },
      { label: "FAQ", href: "/faq" },
      { label: "Privacy Policy", href: "/privacy-policy" },
      { label: "Terms of Service", href: "/terms-of-service" },
    ],
  },
];

export const figmaFeaturePillData = [
  {
    label: "OEM",
    className: "bg-blue-600 text-white",
  },
  {
    label: "OES",
    className: "bg-slate-100 text-slate-700 border border-slate-200",
  },
  {
    label: "Aftermarket",
    className: "bg-slate-100 text-slate-700 border border-slate-200",
  },
];

export const figmaFallbackCategories = [
  "Brake Parts",
  "Engine Parts",
  "Suspension",
  "Electricals",
  "Cooling",
  "Transmission",
  "Exhaust",
  "All Parts",
];
